// extracted by mini-css-extract-plugin
export default {"radioList":"Health_radioList__Udp+d","radioOption":"Health_radioOption__RqDxw","buttonFooter":"Health_buttonFooter__o4kDO","buttonFooterFixed":"Health_buttonFooterFixed__BoZPt"};